import type { PropsWithChildren } from "react";
import React, { memo } from "react";

import { LibraryProvider } from "byzantine";
import { useLocalization } from "@fluent/react";

import webPlatform from "./platform.implementation";
import webNetwork from "./network.implementation";
import useWebToasts from "./toasts.implmentation";
import { config } from "./config";
import webPKCE from "./pkce.implementation";

import type { PreloadedState } from "byzantine";

type Props = {
  preloadedState: PreloadedState;
};

const DBBLLibraryProvider = ({
  preloadedState,
  children,
}: PropsWithChildren<Props>) => {
  const toasts = useWebToasts();
  const { l10n } = useLocalization();

  return (
    <LibraryProvider
      platform={webPlatform}
      network={webNetwork}
      toasts={toasts}
      preloadedState={preloadedState}
      translations={l10n}
      config={config}
      pkce={webPKCE}
    >
      {children}
    </LibraryProvider>
  );
};

export default memo(DBBLLibraryProvider);
